import React, { useEffect, useState } from 'react';
import {
  Table,
  Form,
  Input,
  Switch,
  InputNumber,
  Button,
  Tabs,
  Col,
  Select,
  Upload,
  Modal,
  message,
  Checkbox,
} from 'antd';
import styled from 'styled-components';
import axios from 'axios';
import qs from 'qs';
import { GrClose } from 'react-icons/gr';
import { FaPencilAlt } from 'react-icons/fa';
import {
  LoadingOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import DisplayControl from './DisplayControl';
import consts from '../consts';

const { Option } = Select;
const { TabPane } = Tabs;

const Wrapper = styled.div`
    margin-right: 10px;
`;

const IconWrapper = styled.div`
    &>* {
        margin-right: 1rem;
    }

    &>*:hover {
        cursor:pointer;
    }
`;

const RightWrapper = styled.div`
width: 100%;
text-align: right;
`;

const layout = {
  labelCol: { span: 1 },
  wrapperCol: { span: 23 },
};

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
}

function LuckyGameConfig(props) {
  const [prizeModalVisible, setPrizeModalVisible] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [addPrize, setAddPrize] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [currentPrize, setCurrentPrize] = useState([]);
  const [form] = Form.useForm();
  const [prizeForm] = Form.useForm();

  const onEditPrize = (value) => {
    setAddPrize(false);
    setPrizeModalVisible(true);
    prizeForm.setFieldsValue(value);
    setImageUrl(value.image);
  };

  const onAddPrize = () => {
    setAddPrize(true);
    setPrizeModalVisible(true);
    prizeForm.resetFields();
    setImageUrl(null);
  };

  const closePrizeModel = () => {
    setPrizeModalVisible(false);
  };

  const updatePrize = (values) => {
    props.updatePrize(values);
    closePrizeModel();
  };

  const createPrize = (values) => {
    props.createPrize(values);
    closePrizeModel();
  };

  const onCheckboxChange = (item, checked) => {
    let temp = [...currentPrize];
    if (checked) {
      temp.push({ prize: item.id, rate: 0 });
    } else {
      temp = temp.filter((i) => (i.prize !== item.id));
    }
    setCurrentPrize(temp);
  };

  const onInputNumberChange = (value, index) => {
    const temp = [...currentPrize];
    temp[index].rate = value;
    setCurrentPrize(temp);
  };

  const onUpdateConfig = (values) => {
    const temp = { ...props.config };
    values.list_prize = currentPrize;
    temp.configs = values;
    props.updateConfig(temp);
  };

  const prizeColumn = [
    {
      render: (text, record) => (
        <Checkbox
          {...currentPrize.findIndex(
            (item) => (item.prize === record.id),
          )
                    !== -1
            ? { ...{ checked: true } } : { ...{ checked: false } }}

          onChange={(e) => {
            onCheckboxChange(record, e.target.checked);
          }}
        />
      ),
    },
    {
      title: 'Mã',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Tên',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Ảnh',
      dataIndex: 'image',
      key: 'image',
      render: (text) => (
        <img
          height={80}
          src={text}
        />
      ),
    },
    {
      title: 'Số lượng',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Loại',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: () => (
        <RightWrapper>
          <Button onClick={onAddPrize}>
            Thêm phần quà
          </Button>
        </RightWrapper>
      ),
      width: '10%',
      render: (text, record) => (
        <RightWrapper>
          <IconWrapper>
            <FaPencilAlt onClick={() => onEditPrize(record)} />
            <GrClose />
          </IconWrapper>
        </RightWrapper>
      ),
    },
  ];

  const configColumn = [
    {
      title: 'Mã',
      dataIndex: 'prize',
    },
    {
      title: 'Tên',
      render: (text, record) => (
        <div>
          {(props.prize.find((item) => (item.id === record.prize)) || { name: '' }).name}
        </div>
      ),
    },
    {
      title: 'Giá trị',
      render: (text, record) => (
        <div>
          {(props.prize.find((item) => (item.id === record.prize)) || { amount: 0 }).amount}
        </div>
      ),
    },
    {
      title: 'Tỉ lệ',
      dataIndex: 'rate',
      key: 'rate',
      render: (text, record, index) => (
        isEdit
          ? (
            <InputNumber
              defaultValue={record.rate}
              min={0}
              max={1}
              onChange={(value) => {
                onInputNumberChange(value, index);
              }}
            />
          )
          : <div>{text}</div>
      ),
    },

  ];

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      const formData = new FormData();
      formData.append('files', file);
      const customAxios = axios.create({
        baseURL: 'https://upload.photocloud.mobilelab.vn',
        headers: {
          'Content-Type': 'multipart/form-data',
          Origin: 'https://admin.crypto.mobilelab.vn',
        },
        paramsSerializer(params) {
          return qs.stringify(params);
        },
      });
      customAxios.post('upload', formData).then((resp) => {
        prizeForm.setFieldsValue({
          image: resp.data.uploaded_files[0],
        });
        setImageUrl(resp.data.uploaded_files[0]);
      });
      onSuccess('ok');
    }, 0);
  };

  useEffect(() => {
    props.fetchPrize();
    props.fetchConfig();
  }, []);

  useEffect(() => {
    form.setFieldsValue({ ...props.config.configs });
  }, [props.config]);

  useEffect(() => {
    setCurrentPrize(props.configPrizes);
  }, [props.configPrizes]);

  return (
    <div className="list-user">

      <h3>Vòng quay may mắn</h3>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Cài đặt" key="1">
          <div className="lucky-game">
            <div className="center">
              <Table
                columns={configColumn}
                dataSource={currentPrize}
                pagination={false}
                footer={() => (
                  <div>
                    <Button
                      onClick={() => {
                        setIsEdit(!isEdit);
                      }}
                    >
                      {isEdit ? 'Xác nhận' : 'Chỉnh sửa'}
                    </Button>
                  </div>
                )}
              />

              <Form
                {...layout}
                form={form}
                layout="hor"
                onFinish={onUpdateConfig}
                initialValues={{
                  is_share: {
                    0: true,
                    1: true,
                    2: true,
                    3: true,
                    4: true,
                    5: true,
                  },
                }}
              >

                <Form.Item>
                  <Input.Group>
                    <Form.Item
                      label="Facebook"
                      name={['is_share', '0']}
                      valuePropName={form.getFieldValue(['is_share', '0']) ? 'checked' : ''}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      label="Google"
                      name={['is_share', '1']}
                      valuePropName={form.getFieldValue(['is_share', '1']) ? 'checked' : ''}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      label="Youtube"
                      name={['is_share', '2']}
                      valuePropName={form.getFieldValue(['is_share', '2']) ? 'checked' : ''}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      label="Instagram"
                      name={['is_share', '3']}
                      valuePropName={form.getFieldValue(['is_share', '3']) ? 'checked' : ''}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      label="Zalo"
                      name={['is_share', '4']}
                      valuePropName={form.getFieldValue(['is_share', '4']) ? 'checked' : ''}
                    >
                      <Switch />
                    </Form.Item>
                    <Form.Item
                      label="Telegram"
                      name={['is_share', '5']}
                      valuePropName={form.getFieldValue(['is_share', '5']) ? 'checked' : ''}
                    >
                      <Switch />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>

                <Form.Item>
                  <Input.Group>
                    <Form.Item
                      label="Giới hạn"
                      name="limit"
                    >
                      <InputNumber />
                    </Form.Item>
                    <Form.Item
                      label="Trao đổi"
                      name="time_trade"
                    >
                      <InputNumber />
                    </Form.Item>
                    <Form.Item
                      label="Giao dịch"
                      name="time_transaction"
                    >
                      <InputNumber />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>

              </Form>

              <div>
                <DisplayControl permission_link_screen={consts.AUTH.CAMPAIGN__CONFIG} action={consts.CONTROLS.PUT}>
                  <Button
                    onClick={() => {
                      form.submit();
                    }}
                    type="primary"
                  >
                    Xác nhận
                  </Button>
                </DisplayControl>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane tab="Phần thưởng" key="2">
          <Table columns={prizeColumn} dataSource={props.prize} />
          <Modal
            title={addPrize ? 'Thêm phần thưởng' : 'Sửa phần thưởng'}
            visible={prizeModalVisible}
            onCancel={closePrizeModel}
            footer={false}
          >
            <Form
              {...layout}
              form={prizeForm}
              onFinish={addPrize ? createPrize : updatePrize}
            >
              <Form.Item
                label="Mã"
                name="id"
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                label="Tên phần thưởng"
                name="name"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Số lượng"
                name="amount"
              >
                <InputNumber min={0} />
              </Form.Item>
              <Form.Item
                label="Loại quà"
                name="type"
              >
                <Select>
                  <Option value={0}>Trong ứng dụng</Option>
                  <Option value={1}>Hiện vật</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="ảnh"
                name="image"
              >
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  customRequest={dummyRequest}
                  beforeUpload={beforeUpload}
                >
                  {
                                        imageUrl
                                          ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
                                          : uploadButton
                                    }
                </Upload>
              </Form.Item>
              <Form.Item className="center">
                {addPrize
                  ? (
                    <DisplayControl permission_link_screen={consts.AUTH.PRIZE} action={consts.CONTROLS.POST}>
                      <Button type="primary" htmlType="submit">
                        Thêm
                      </Button>
                    </DisplayControl>
                  )
                  : (
                    <DisplayControl permission_link_screen={consts.AUTH.PRIZE__iD} action={consts.CONTROLS.PUT}>
                      <Button type="primary" htmlType="submit">
                        Sửa
                      </Button>
                    </DisplayControl>
                  )}
              </Form.Item>
            </Form>
          </Modal>
        </TabPane>
      </Tabs>

    </div>
  );
}

export default LuckyGameConfig;
